import { CreateStatusDto, DeleteStatusDto, EditStatusDto, GetStatusDto, MessageResponseDto, UtilityStatusApiFp, UtilStatusControllerGet200Response } from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseStatusModel = UtilStatusControllerGet200Response;
export type GetStatusModel = GetStatusDto;
export type MutateResponseStatusModel = MessageResponseDto;
export type CreateStatusModel = CreateStatusDto;
export type UpdateStatusModel = EditStatusDto;
export type DeleteStatusModel = DeleteStatusDto;

export const apiStatusFp = UtilityStatusApiFp(apiConfig);
export const getStatusController = apiStatusFp.utilStatusControllerGet;
export const createStatusController = apiStatusFp.utilStatusControllerCreate;
export const updateStatusController = apiStatusFp.utilStatusControllerEdit;
export const deleteStatusController = apiStatusFp.utilStatusControllerDelete;

export const QueryKeyStatus = QueryKey.Status;